import { createSlice } from '@reduxjs/toolkit'
import { getCustomerList } from '../Thunk/customerThunk'

const initialState = {
    CustomerList :[],
}

export const customerSlice = createSlice({
          name:'customerThunk',
          initialState,
          reducers:{ 

            
          },

          extraReducers:(builder)=>{
            builder.addCase(getCustomerList.fulfilled,(state,action)=>{
                state.CustomerList = action.payload
            })
         }
})


export const {storeEditCustomerDetails} = customerSlice.actions
export default customerSlice.reducer
